import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';

import styles from './teachers-grid.css';

const { div, p, img, h2, span } = hh(h);

const TeachersGrid = ({teachers=[]}) => {
  if (! teachers || teachers.length === 0) return h('div', []);

  const teachersElements = teachers.map(({ bio, name, image, role }) =>
    div({ className: styles.teacher }, [
      div({ className: styles.teacherImage }, [
        img({ src: image, alt: name })
      ]),
      div({ className: styles.teacherText }, [
        h2({ className: styles.teacherName }, [name, span({ className: styles.teacherRole }, role)]),
        p({ className: styles.teacherBody }, bio)
      ])
    ])
  );

  return h('div', { className: styles.teachersGrid }, teachersElements);
};

TeachersGrid.propTypes = {
  teachers: PropTypes.array
};

export default TeachersGrid;



/** WEBPACK FOOTER **
 ** ./src/TeachersGrid/index.js
 **/